import { GlobalWorkerOptions, getDocument } from "pdfjs-dist";
import pdfWorkerUrl from "pdfjs-dist/build/pdf.worker.min.mjs?url";

// Every proposal PDF, the composed document and a template's backgrounds alike,
// is read through this one worker.
GlobalWorkerOptions.workerSrc = pdfWorkerUrl;

export { getDocument };
